import { FabricIText } from "../objects";
import { TextProps } from "../classes/TextLayer/interfaces";

interface FabricCharStyle {
  fill?: string;
  [key: string]: unknown;
}

interface FabricStyles {
  [lineIndex: number]: {
    [charIndex: number]: FabricCharStyle;
  };
}

const WHITESPACE = /\s/u;

function mapLetterColorsToFabricStyles(
  letterColors: string[],
  text: string,
  fallbackColor = "",
): FabricStyles {
  const styles: FabricStyles = {};
  if (!letterColors?.length || !text) return styles;

  const lines = text.split("\n");
  let colorIndex = 0;

  lines.forEach((line, lineIndex) => {
    Array.from(line).forEach((char, charIndex) => {
      if (WHITESPACE.test(char)) return;

      const color =
        letterColors[colorIndex % letterColors.length] || fallbackColor;
      colorIndex += 1;

      if (!color) return;
      (styles[lineIndex] ??= {})[charIndex] = { fill: color };
    });
  });

  return styles;
}

export default function applyLetterColors(
  itext: FabricIText,
  text: string,
): void {
  const { textColorsByLetter, letterColors } = itext as unknown as TextProps;

  const styles =
    textColorsByLetter && letterColors?.length
      ? mapLetterColorsToFabricStyles(letterColors, text)
      : {};

  itext.set("styles", styles);
}
